import { render } from "./MemoruAlbum.vue?vue&type=template&id=fa0ccf1c&scoped=true&ts=true"
import script from "./MemoruAlbum.vue?vue&type=script&lang=ts"
export * from "./MemoruAlbum.vue?vue&type=script&lang=ts"

import "./MemoruAlbum.vue?vue&type=style&index=0&id=fa0ccf1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0ccf1c"]])

export default __exports__